import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-116458ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-header" }
const _hoisted_2 = { class: "value-inputs" }

import {reactive, ref} from "vue";
import {useRoute} from "vue-router";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'DurationPicker',
  props: {
    modelValue: {},
    limit: {},
    title: {},
    label: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
let value = props.modelValue;
let dialog = ref(false)
let valid = ref(true)
const multipliers = {
  seconds: 1e3,
  minutes: 6e4,
  hours: 36e5,
  days: 864e5
}
let values = reactive({
  seconds: 0,
  minutes: 0,
  hours: 0,
  days: 0
})

Object.keys(values).reverse().forEach(u => {
  let unit = u as  keyof typeof values;
  let num = Math.floor(value / multipliers[unit]);
  if(num > 0) {
    values[unit] = num;
    value -= num * multipliers[unit];
  }
})

const rules = [
  (number: number) => (number >= 0 && !(number % 1)) || i18n.global.t('DurationPicker.invalidNumber'),
  () => countDuration() <= (props.limit || Infinity) || i18n.global.t('DurationPicker.tooLongDuration')
]

function countDuration(): number {
  return Number(values.seconds) * multipliers.seconds
      + Number(values.minutes) * multipliers.minutes
      + Number(values.hours) * multipliers.hours
      + Number(values.days) * multipliers.days
}

function submit() {
  emit('update:modelValue', countDuration());
  dialog.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      icon: "",
      variant: "text",
      color: "primary",
      size: "50",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = true : dialog = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { class: "material-icons-outlined" }, {
          default: _withCtx(() => [
            _createTextVNode("timer")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "modal-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(_ctx.title ?? _ctx.$t('DurationPicker.durationInput')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _unref(valid),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('DurationPicker.enterDuration')), 1),
                    _createElementVNode("div", _hoisted_2, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(values)).reverse(), (unit) => {
                        return (_openBlock(), _createBlock(_component_v_text_field, {
                          modelValue: _unref(values)[unit],
                          "onUpdate:modelValue": ($event: any) => ((_unref(values)[unit]) = $event),
                          class: "value-input",
                          rules: rules,
                          color: "primary",
                          label: _ctx.label ?? _ctx.$t(`DurationPicker.units.${unit}`)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                      }), 256))
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "blue-grey",
                  disabled: _unref(valid) === false,
                  onClick: submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" OK ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})